import { NavLink } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { BrandLogo } from './Logo';

interface NavItem {
  to: string;
  label: string;
  icon: string;
  adminOnly?: boolean;
}

const NAV: NavItem[] = [
  { to: '/app', label: 'Dashboard', icon: '◧' },
  { to: '/app/studio', label: 'Studio', icon: '🎚' },
  { to: '/app/library', label: 'Library', icon: '▣' },
  { to: '/app/wave', label: 'The Wave', icon: '〜' },
  { to: '/app/wave-radio', label: 'Wave Radio', icon: '📻' },
  { to: '/app/arena', label: 'The Arena', icon: '⚔' },
  { to: '/app/battle-rules', label: 'Battle Rules', icon: '📜' },
  { to: '/app/live', label: 'Live Battle', icon: '📺' },
  { to: '/app/collabs', label: 'Collabs', icon: '⚭' },
  { to: '/app/messages', label: 'Messages', icon: '💬' },
  { to: '/app/tiers', label: 'Contracts', icon: '★' },
  { to: '/app/safety', label: 'Safety & Rules', icon: '🛡' },
];

const JUDGE_NAV: NavItem[] = [
  { to: '/app/judge', label: 'Judge Dashboard', icon: '⚖' },
];

const SECONDARY: NavItem[] = [
  { to: '/app/notifications', label: 'Notifications', icon: '🔔' },
  { to: '/app/profile', label: 'Profile / Settings', icon: '⚙' },
];

export function Sidebar({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const { currentUser, logout, theme, toggleTheme } = useApp();
  const isAdmin = currentUser?.role === 'ADMIN';
  const isJudge = currentUser?.role === 'JUDGE' || isAdmin;

  return (
    <aside className={`sidebar${open ? ' open' : ''}`}>
      <div className="brand">
        <BrandLogo height={42} />
      </div>

      <nav onClick={onClose}>
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/app'}
            className={({ isActive }) =>
              `nav-link${isActive ? ' active' : ''}`
            }
          >
            <span className="nav-ico">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}

        {isJudge && (
          <>
            <div className="nav-divider" />
            {JUDGE_NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `nav-link${isActive ? ' active' : ''}`
                }
              >
                <span className="nav-ico">{item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </>
        )}

        <div className="nav-divider" />

        {SECONDARY.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `nav-link${isActive ? ' active' : ''}`
            }
          >
            <span className="nav-ico">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}

        <button className="nav-link" onClick={toggleTheme}>
          <span className="nav-ico">{theme === 'dark' ? '☀' : '☾'}</span>
          Theme: {theme === 'dark' ? 'Light' : 'Dark'}
        </button>

        <button className="nav-link" onClick={logout}>
          <span className="nav-ico">⏻</span>
          Logout
        </button>

        {isAdmin && (
          <>
            <div className="nav-divider" />
            <NavLink
              to="/app/admin"
              className={({ isActive }) =>
                `nav-link nav-admin${isActive ? ' active' : ''}`
              }
            >
              <span className="nav-ico">🗝</span>
              Admin / Control Room
            </NavLink>
          </>
        )}
      </nav>
    </aside>
  );
}
